class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Detección de país (CL?) - por defecto false hasta que lo detectemos
    this.visitorCountry = null;
    this.isChile = false;

    // 🚚 Configuración de envío gratis - Doble meta
    this.freeShippingSantiago = 10000000; // Meta Santiago
    this.freeShippingRegiones = 10000000; // Meta Regiones

    // 🔥 Cargar precios de los productos al iniciar
    this.loadShippingThresholds();

    // Seguridad: si no existe el contenedor, creamos uno mínimo para que el componente no rompa
    if (!this.notification) {
      const el = document.createElement('div');
      el.id = 'cart-notification';
      el.tabIndex = -1;
      document.body.appendChild(el);
      this.notification = el;
    }

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Estilos y overlay
    this.applySlideCartStyles();

    // Delegación de clicks interna (se usarán para + / - y agregar)
    this.notification.addEventListener('click', (e) => this.handleInternalClick(e));

    console.log('✅ SLIDE CART lateral activado - Con soporte mejorado para conversión de moneda');
  }

  // 💱 MEJORADO: Dispara la conversión de moneda de forma más agresiva y robusta
  triggerCurrencyConversion() {
    try {
      console.log('💱 Disparando conversión de moneda...');

      // Método 1: Evento DOMContentLoaded
      const event = new Event('DOMContentLoaded');
      document.dispatchEvent(event);

      // Método 2: Currency.convertAll()
      if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
        setTimeout(() => {
          Currency.convertAll();
          console.log('💱 Currency.convertAll() ejecutado');
        }, 50);
      }

      // Método 3: MLV Auto Currency Switcher
      if (typeof mlveda_switcher !== 'undefined') {
        setTimeout(() => {
          if (typeof mlveda_switcher.convertAll === 'function') {
            mlveda_switcher.convertAll();
            console.log('💱 mlveda_switcher.convertAll() ejecutado');
          }
        }, 50);
      }

      // Método 4: Forzar reprocesamiento de elementos .money dentro del slide cart
      setTimeout(() => {
        const moneyElements = this.notification.querySelectorAll('.money');
        console.log(`💱 ${moneyElements.length} elementos .money encontrados en el slide cart`);
        
        // Trigger de eventos en cada elemento
        moneyElements.forEach(el => {
          const changeEvent = new Event('DOMNodeInserted', { bubbles: true });
          el.dispatchEvent(changeEvent);
        });
      }, 100);

      // Método 5: MutationObserver fallback (para plugins que escuchan cambios en el DOM)
      const triggerMutation = () => {
        const tempEl = document.createElement('span');
        tempEl.className = 'money';
        tempEl.style.display = 'none';
        this.notification.appendChild(tempEl);
        setTimeout(() => tempEl.remove(), 10);
      };
      setTimeout(triggerMutation, 150);

    } catch (error) {
      console.warn('⚠️ Error disparando conversión de moneda:', error);
    }
  }

  // 💰 MEJORADO: Genera HTML con atributos data-currency-* para mejor compatibilidad
  formatPriceForConversion(priceInCents) {
    const amountInCLP = priceInCents / 100;
    // Detectar la moneda activa SIEMPRE desde el plugin
    let currency = 'CLP';
    if (typeof mlveda_switcher !== 'undefined' && mlveda_switcher.currentCurrency) {
      currency = mlveda_switcher.currentCurrency;
    } else if (typeof Currency !== 'undefined' && Currency.currentCurrency) {
      currency = Currency.currentCurrency;
    } else {
      const storedCurrency = localStorage.getItem('currency') || localStorage.getItem('selected_currency');
      if (storedCurrency) currency = storedCurrency;
    }

    // SIEMPRE mostrar el precio en la moneda activa, NUNCA CLP si la moneda es otra
    // El plugin se encarga de convertir y mostrar el formato correcto
    // Solo mostrar CLP si la moneda activa es CLP
    if (currency === 'CLP') {
      return `<span class="dinero" data-currency-clp="${amountInCLP}"><span class="money" data-currency="CLP" data-amount="${amountInCLP}">$${Math.round(amountInCLP).toLocaleString('es-CL')}</span></span>`;
    } else {
      // Mostrar el valor en CLP para que el plugin lo convierta, sin formato local
      return `<span class="dinero" data-currency-clp="${amountInCLP}"><span class="money" data-currency="CLP" data-amount="${amountInCLP}">${amountInCLP}</span></span>`;
    }
  }

  // 💰 Formato simple para mensajes (sin conversión)
  formatNumber(number) {
    return Math.ceil(number).toLocaleString('es-CL');
  }

  // 🌍 Detecta la moneda actual del plugin
  getCurrentCurrency() {
    try {
      // Método 1: Variable global del plugin MLV
      if (typeof mlveda_switcher !== 'undefined' && mlveda_switcher.currentCurrency) {
        return mlveda_switcher.currentCurrency;
      }

      // Método 2: Variable global Currency
      if (typeof Currency !== 'undefined' && Currency.currentCurrency) {
        return Currency.currentCurrency;
      }

      // Método 3: Buscar en el DOM el selector de moneda
      const currencySelector = document.querySelector('[name="currencies"], #currencies, .currency-picker select');
      if (currencySelector && currencySelector.value) {
        return currencySelector.value;
      }

      // Método 4: Buscar en localStorage
      const storedCurrency = localStorage.getItem('currency') || localStorage.getItem('selected_currency');
      if (storedCurrency) {
        return storedCurrency;
      }

      // Por defecto: CLP
      return 'CLP';
    } catch (error) {
      console.warn('⚠️ Error detectando moneda actual:', error);
      return 'CLP';
    }
  }

  // Detecta el país del visitante
  async detectVisitorCountry() {
    try {
      // 1) Override por query param para desarrollo/test: ?geo=CL o ?geo=US
      const params = new URLSearchParams(window.location.search);
      const forced = params.get('geo');
      if (forced) {
        this.visitorCountry = forced.toUpperCase();
        this.isChile = this.visitorCountry === 'CL';
        console.log('🌍 País forzado por query param:', this.visitorCountry);
        return this.visitorCountry;
      }

      // 2) Cache local
      const cacheRaw = localStorage.getItem('visitor_country_cache');
      if (cacheRaw) {
        try {
          const cache = JSON.parse(cacheRaw);
          const age = Date.now() - (cache.ts || 0);
          if (cache.country && age < 24 * 60 * 60 * 1000) {
            this.visitorCountry = cache.country;
            this.isChile = this.visitorCountry === 'CL';
            console.log('🌍 País desde cache:', this.visitorCountry);
            return this.visitorCountry;
          }
        } catch (e) {}
      }

      // 3) Intentar detectar vía IP pública con timeout
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 2500);

      try {
        const res = await fetch('https://ipapi.co/json/', { signal: controller.signal });
        clearTimeout(timeout);
        if (res.ok) {
          const data = await res.json();
          if (data && data.country) {
            this.visitorCountry = String(data.country).toUpperCase();
            this.isChile = this.visitorCountry === 'CL';
            localStorage.setItem('visitor_country_cache', JSON.stringify({ country: this.visitorCountry, ts: Date.now() }));
            console.log('🌍 País detectado por IP:', this.visitorCountry);
            return this.visitorCountry;
          }
        }
      } catch (err) {
        console.warn('⚠️ No se pudo detectar país por IP:', err && err.name ? err.name : err);
      }

      // 4) Fallback
      const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
      if (nav.includes('cl')) {
        this.visitorCountry = 'CL';
        this.isChile = true;
        console.log('🌍 País inferido por navigator.language');
        localStorage.setItem('visitor_country_cache', JSON.stringify({ country: this.visitorCountry, ts: Date.now() }));
        return this.visitorCountry;
      }

      this.visitorCountry = 'ZZ';
      this.isChile = false;
      console.log('🌍 País no detectado, asumiendo visitante NO-CL');
      localStorage.setItem('visitor_country_cache', JSON.stringify({ country: this.visitorCountry, ts: Date.now() }));
      return this.visitorCountry;
    } catch (e) {
      console.error('❌ Error detectando país:', e);
      this.visitorCountry = 'ZZ';
      this.isChile = false;
      return this.visitorCountry;
    }
  }

  async loadShippingThresholds() {
    try {
      const resSantiago = await fetch('/products/enviogratis.js');
      const productSantiago = await resSantiago.json();
      
      if (productSantiago && productSantiago.price) {
        this.freeShippingSantiago = productSantiago.price;
        console.log('✅ Meta Santiago: $' + (productSantiago.price / 100).toLocaleString('es-CL'));
      }

      const resRegiones = await fetch('/products/enviogratisregiones.js');
      const productRegiones = await resRegiones.json();
      
      if (productRegiones && productRegiones.price) {
        this.freeShippingRegiones = productRegiones.price;
        console.log('✅ Meta Regiones: $' + (productRegiones.price / 100).toLocaleString('es-CL'));
      }
    } catch (error) {
      console.warn('⚠️ Error cargando productos de envío:', error);
    }
  }

  applySlideCartStyles() {
    Object.assign(this.notification.style, {
      position: 'fixed',
      top: '0',
      right: '0',
      width: '450px',
      maxWidth: '100%',
      height: '100vh',
      maxHeight: '100vh',
      margin: '0',
      transform: 'translateX(100%)',
      transition: 'transform 0.3s ease-in-out',
      zIndex: '9999',
      backgroundColor: '#ffffff',
      boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.15)',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column'
    });

    if (!document.getElementById('cart-overlay')) {
      const overlay = document.createElement('div');
      overlay.id = 'cart-overlay';
      Object.assign(overlay.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: '9998',
        opacity: '0',
        visibility: 'hidden',
        transition: 'opacity 0.3s ease, visibility 0.3s ease'
      });
      overlay.addEventListener('click', () => this.close());
      document.body.appendChild(overlay);
      this.overlay = overlay;
    } else {
      this.overlay = document.getElementById('cart-overlay');
    }

    const updateWidth = () => {
      this.notification.style.width = window.innerWidth <= 768 ? '100%' : '450px';
    };
    updateWidth();
    window.addEventListener('resize', updateWidth);
  }

  async open() {
    console.log('🔄 Abriendo carrito...');
    
    if (this.notification.classList.contains('active')) {
      console.log('⚠️ El carrito ya está abierto');
      return;
    }

    try {
      this.notification.classList.add('animate', 'active');
      this.notification.style.transform = 'translateX(0)';

      if (this.overlay) {
        this.overlay.style.opacity = '1';
        this.overlay.style.visibility = 'visible';
      }

      document.documentElement.style.overflowY = 'hidden';
      document.body.style.overflowY = 'hidden';

      await this.detectVisitorCountry();
      await this.loadFullCart();

      this.notification.addEventListener(
        'transitionend',
        () => {
          try { this.notification.focus(); } catch (e) {}
          if (typeof trapFocus === 'function') trapFocus(this.notification);
        },
        { once: true }
      );

      document.body.addEventListener('click', this.onBodyClick);
      console.log('✅ SLIDE CART ABIERTO');
    } catch (error) {
      console.error('❌ Error abriendo el carrito:', error);
    }
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.style.transform = 'translateX(100%)';

    if (this.overlay) {
      this.overlay.style.opacity = '0';
      this.overlay.style.visibility = 'hidden';
    }

    document.documentElement.style.overflowY = '';
    document.body.style.overflowY = '';

    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);

    console.log('❌ SLIDE CART CERRADO');

    setTimeout(() => {
      this.updateCartIcon();
    }, 300);
  }

  async updateCartIcon() {
    try {
      console.log('🔄 Actualizando ícono del carrito...');
      const sections = ['cart-icon-bubble', 'cart-count-bubble', 'cart-drawer-icon', 'cart-icon'];
      const response = await fetch(`/cart?sections=${sections.join(',')}`);
      const data = await response.json();

      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el && data[id]) {
          el.innerHTML = this.getSectionInnerHTML(data[id]);
        }
      });

      console.log('✅ Ícono del carrito sincronizado');
    } catch (error) {
      console.error('❌ Error al actualizar ícono del carrito:', error);
    }
  }

  async loadFullCart() {
    try {
      console.log('📦 Cargando carrito completo...');
      const response = await fetch('/cart.js');
      const cart = await response.json();

      console.log('📦 Carrito cargado:', cart);

      this.renderFullCart(cart);

      // 💱 MEJORADO: Conversión de moneda en cascada con delays incrementales
      this.triggerCurrencyConversion();
      setTimeout(() => this.triggerCurrencyConversion(), 300);
      setTimeout(() => this.triggerCurrencyConversion(), 600);
      setTimeout(() => this.triggerCurrencyConversion(), 1000);

      this.updateProgressBarAnimation(cart.total_price);

      await this.loadRecommendations(cart);
    } catch (error) {
      console.error('❌ Error cargando carrito:', error);
    }
  }

  updateProgressBarAnimation(totalPrice) {
    // Re-verificar el país en cada actualización para capturar cambios manuales
    const cacheRaw = localStorage.getItem('visitor_country_cache');
    let currentCountry = this.visitorCountry || 'ZZ';
    if (cacheRaw) {
      try {
        const cache = JSON.parse(cacheRaw);
        if (cache.country) currentCountry = cache.country;
      } catch (e) {}
    }
    
    // Si no es visitante chileno, no actualizar la barra de envío gratis
    if (currentCountry !== 'CL') return;

    const progressBar1 = this.notification.querySelector('#shipping-progress-bar-1');
    const progressBar2 = this.notification.querySelector('#shipping-progress-bar-2');
    const progressText = this.notification.querySelector('#shipping-progress-text');
    const progressTitle = this.notification.querySelector('#shipping-progress-title');
    const milestone1 = this.notification.querySelector('#milestone-1');
    const milestone2 = this.notification.querySelector('#milestone-2');
    
    if (!progressBar1 || !progressBar2) {
      console.warn('⚠️ Barras de progreso no encontradas');
      return;
    }

    const currentAmount = totalPrice / 100;
    const thresholdSantiago = this.freeShippingSantiago / 100;
    const thresholdRegiones = this.freeShippingRegiones / 100;
    const currentCurrency = this.getCurrentCurrency();
    
    const percentage1 = Math.min((currentAmount / thresholdSantiago) * 50, 50);
    const percentage2 = currentAmount > thresholdSantiago 
      ? Math.min(((currentAmount - thresholdSantiago) / (thresholdRegiones - thresholdSantiago)) * 50, 50)
      : 0;
    
    const completedSantiago = currentAmount >= thresholdSantiago;
    const completedRegiones = currentAmount >= thresholdRegiones;

    requestAnimationFrame(() => {
      progressBar1.style.width = `${percentage1}%`;
      progressBar2.style.width = `${percentage2}%`;
    });

    if (milestone1) {
      milestone1.style.backgroundColor = completedSantiago ? '#700e25' : '#fff';
      milestone1.style.borderColor = completedSantiago ? '#700e25' : '#ddd';
      
      const icon1 = milestone1.querySelector('.milestone-icon');
      if (icon1) {
        icon1.innerHTML = completedSantiago ? '✓' : '';
        icon1.style.color = completedSantiago ? '#fff' : 'transparent';
      }
    }

    if (milestone2) {
      milestone2.style.backgroundColor = completedRegiones ? '#700e25' : '#fff';
      milestone2.style.borderColor = completedRegiones ? '#700e25' : '#ddd';
      
      const icon2 = milestone2.querySelector('.milestone-icon');
      if (icon2) {
        icon2.innerHTML = completedRegiones ? '✓' : '';
        icon2.style.color = completedRegiones ? '#fff' : 'transparent';
      }
    }

    if (progressTitle) {
      if (completedRegiones) {
        progressTitle.innerHTML = '🎉 <span>¡Envío gratis a todo Chile!</span>';
        progressTitle.style.color = '#228B22';
      } else if (completedSantiago) {
        progressTitle.innerHTML = '🎉 <span>¡Envío gratis a Santiago! Sigue comprando para regiones</span>';
        progressTitle.style.color = '#700e25';
      } else {
        progressTitle.innerHTML = '<span>Consigue tu Envío gratis</span>';
        progressTitle.style.color = '#1a1a1a';
      }
    }

    if (progressText) {
      if (completedRegiones) {
        progressText.innerHTML = '';
      } else if (completedSantiago) {
        const remainingRegiones = Math.ceil(thresholdRegiones - currentAmount);
        progressText.innerHTML = `<span>Faltan</span> <strong style="color:#700e25;">$${this.formatNumber(remainingRegiones)}</strong> <span>para envío gratis a regiones</span>`;
      } else {
        const remainingSantiago = Math.ceil(thresholdSantiago - currentAmount);
        progressText.innerHTML = `<span>Faltan</span> <strong style="color:#700e25;">$${this.formatNumber(remainingSantiago)}</strong> <span>para envío gratis a Santiago</span>`;
      }
    }
  }

  renderShippingProgressBar(totalPrice) {
    // Re-verificar el país en cada render para capturar cambios manuales del usuario
    // Primero intenta el cache local, luego la propiedad de instancia
    const cacheRaw = localStorage.getItem('visitor_country_cache');
    let currentCountry = this.visitorCountry || 'ZZ';
    if (cacheRaw) {
      try {
        const cache = JSON.parse(cacheRaw);
        if (cache.country) currentCountry = cache.country;
      } catch (e) {}
    }
    
    // Si el visitante NO es de Chile, no mostramos información de envío gratis
    if (currentCountry !== 'CL') return '';

    const currentAmount = totalPrice / 100;
    const thresholdSantiago = this.freeShippingSantiago / 100;
    const thresholdRegiones = this.freeShippingRegiones / 100;
    
    const percentage1 = Math.min((currentAmount / thresholdSantiago) * 50, 50);
    const percentage2 = currentAmount > thresholdSantiago 
      ? Math.min(((currentAmount - thresholdSantiago) / (thresholdRegiones - thresholdSantiago)) * 50, 50)
      : 0;
    
    const completedSantiago = currentAmount >= thresholdSantiago;
    const completedRegiones = currentAmount >= thresholdRegiones;
    const remainingSantiago = Math.max(thresholdSantiago - currentAmount, 0);
    const remainingRegiones = Math.max(thresholdRegiones - currentAmount, 0);

    const currentCurrency = this.getCurrentCurrency();
    const isShowingCLP = currentCurrency === 'CLP';

    if (!isShowingCLP) {
      return `
        <div id="shipping-progress" style="position:sticky; top:56px; z-index:10; background:#fff; padding:20px; border-bottom:1px solid #eee; box-sizing:border-box; text-align:center;">
          <div id="shipping-progress-title" style="font-size:14px; font-weight:700; color:#f8f9fa; margin-bottom:8px;"></div>
          <div id="shipping-progress-text" style="font-size:13px; color:#666;"></div>
        </div>
      `;
    }

    return `
      <div id="shipping-progress" style="position:sticky; top:56px; z-index:10; background:#fff; padding:20px; border-bottom:1px solid #eee; will-change:top,transform; box-sizing:border-box;">
        <div id="shipping-progress-title" style="font-size:14px; font-weight:700; color:${completedRegiones ? '#228B22' : '#1a1a1a'}; margin-bottom:8px; text-align:center;">
          ${completedRegiones ? '🎉 <span>¡Envío gratis a todo Chile!</span>' : completedSantiago ? '🎉 <span>¡Envío gratis a Santiago! Sigue comprando para regiones</span>' : '<span>Consigue tu Envío gratis</span>'}
        </div>
        
        <div id="shipping-progress-text" style="font-size:13px; color:#666; margin-bottom:16px; text-align:center;">
          ${completedRegiones 
            ? '' 
            : completedSantiago 
              ? `<span>Faltan</span> <strong style="color:#700e25;">$${this.formatNumber(remainingRegiones)}</strong> <span>para envío gratis a regiones</span>`
              : `<span>Faltan</span> <strong style="color:#700e25;">$${this.formatNumber(remainingSantiago)}</strong> <span>para envío gratis a Santiago</span>`}
        </div>

        <div style="position:relative; height:10px; background:#f1f1f1; border-radius:999px; overflow:visible; margin-bottom:24px;">
          <div id="shipping-progress-bar-1" style="position:absolute; left:0; width:${percentage1}%; height:100%; background:#700e25; border-radius:999px 0 0 999px; transition:width 0.6s ease; z-index:2;"></div>
          <div id="shipping-progress-bar-2" style="position:absolute; left:50%; width:${percentage2}%; height:100%; background:#700e25; border-radius:0 999px 999px 0; transition:width 0.6s ease; z-index:2;"></div>
          
          <div id="milestone-1" style="position:absolute; left:50%; top:50%; transform:translate(-50%, -50%); width:24px; height:24px; background:${completedSantiago ? '#700e25' : '#fff'}; border:3px solid ${completedSantiago ? '#700e25' : '#ddd'}; border-radius:50%; z-index:3; display:flex; align-items:center; justify-content:center; box-shadow:0 2px 4px rgba(0,0,0,0.1); transition:all 0.3s ease;">
            <span class="milestone-icon" style="font-size:12px; font-weight:700; color:${completedSantiago ? '#fff' : 'transparent'};">✓</span>
          </div>
          
          <div id="milestone-2" style="position:absolute; right:0; top:50%; transform:translate(50%, -50%); width:24px; height:24px; background:${completedRegiones ? '#700e25' : '#fff'}; border:3px solid ${completedRegiones ? '#700e25' : '#ddd'}; border-radius:50%; z-index:3; display:flex; align-items:center; justify-content:center; box-shadow:0 2px 4px rgba(0,0,0,0.1); transition:all 0.3s ease;">
            <span class="milestone-icon" style="font-size:12px; font-weight:700; color:${completedRegiones ? '#fff' : 'transparent'};">✓</span>
          </div>
        </div>

        <div style="display:flex; justify-content:space-between; padding:0 12px;">
          <div style="text-align:center;">
            <div style="font-size:11px; font-weight:600; color:${completedSantiago ? '#228B22' : '#700e25'};">
              ${completedSantiago ? '<span>Envío Gratis</span>' : '<span>Envío Gratis</span>'}
            </div>
            <div style="font-size:10px; color:#999; margin-top:2px;"><span>Santiago</span></div>
          </div>
          <div style="text-align:center;">
            <div style="font-size:11px; font-weight:600; color:${completedRegiones ? '#228B22' : '#700e25'};">
              ${completedRegiones ? '<span>Envío Gratis</span>' : '<span>Envío Gratis</span>'}
            </div>
            <div style="font-size:10px; color:#999; margin-top:2px;"><span>Regiones</span></div>
          </div>
        </div>
      </div>
    `;
  }

  renderFullCart(cart) {
    let fullCartContainer = this.notification.querySelector('#full-cart-items');

    if (!fullCartContainer) {
      fullCartContainer = document.createElement('div');
      fullCartContainer.id = 'full-cart-items';
      fullCartContainer.style.cssText = `
        padding: 0;
        flex: 1;
        overflow-y: auto;
        position: relative;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
      `;
      this.notification.insertBefore(fullCartContainer, this.notification.firstChild);
    }

let cartHTML = `<div style="padding:20px;">`;

// Mostrar aviso de referencia de moneda SOLO si la moneda activa NO es CLP
const currentCurrency = this.getCurrentCurrency();
const currencyNotice = currentCurrency !== 'CLP' ? `
    <div style="font-size:12px; font-weight:400; color:#666; margin-top:8px; line-height:1.4;">
      Los precios se muestran en EUR o DÓLARES solo de forma referencial.<br>
      El pago se procesará en pesos chilenos (CLP) según la tasa de cambio del día.
    </div>
  ` : '';

cartHTML += `
  <h3 style="margin:0; padding:40px 20px 14px; font-size:20px; font-weight:600; color:#1a1a1a; 
      position:sticky; top:0; background-color:#fff; z-index:11; will-change:top,transform; box-sizing:border-box;">
    <span>Tu Carrito</span> (${cart.item_count} <span>${cart.item_count === 1 ? 'producto' : 'productos'}</span>)
    ${currencyNotice}
  </h3>
`;

    if (cart.items.length > 0) {
      cartHTML += this.renderShippingProgressBar(cart.total_price);
    }

    if (cart.items.length === 0) {
      cartHTML += `
        <div style="text-align:center; padding:40px 0; color:#999;">
          <p style="font-size:16px; margin:0;"><span>Tu carrito está vacío</span></p>
        </div>
      `;
    } else {
      cart.items.forEach((item) => {
        const hasDiscount = item.original_line_price !== item.final_line_price;
        const variantId = item.variant_id;

        cartHTML += `
          <div class="cart-item" data-variant-id="${variantId}" style="display:flex; gap:12px; padding:12px; border:1px solid #eaeaea; border-radius:8px; margin-bottom:12px; background:#fff;">
            ${item.image ? `
              <div style="flex-shrink:0;">
                <a href="/products/${item.handle || ''}" style="display:block; text-decoration:none;">
                  <img src="${item.image}" alt="${item.title}" style="width:80px; height:80px; object-fit:cover; border-radius:6px;">
                </a>
              </div>` : ''
        }
            <div style="flex:1; min-width:0;">
              <div style="display:flex; justify-content:space-between; gap:12px;">
                <div style="min-width:0;">
                  ${item.vendor ? `<p style="font-size:11px; text-transform:uppercase; color:#999; margin:0 0 4px;">${item.vendor}</p>` : ''}
                  <a href="/products/${item.handle || ''}" style="text-decoration:none;">
                    <h4 style="margin:0; font-size:14px; font-weight:600; color:#1a1a1a; line-height:1.2; overflow:hidden; text-overflow:ellipsis; cursor:pointer; transition:color 0.2s;">${item.product_title}</h4>
                  </a>
                  ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:12px; color:#666; margin:4px 0 0;">${item.variant_title}</p>` : ''}
                </div>
                <div style="text-align:right;">
                  ${hasDiscount ? `<div style="font-size:12px; color:#999; text-decoration:line-through;">${this.formatPriceForConversion(item.original_line_price)}</div>` : ''}
                  <div style="font-size:16px; font-weight:700; color:#1a1a1a;">${this.formatPriceForConversion(item.final_line_price)}</div>
                </div>
              </div>

              <div style="display:flex; align-items:center; justify-content:space-between; margin-top:10px;">
                <div style="display:flex; align-items:center; gap:8px;">
                  <button class="qty-decrease" data-variant-id="${variantId}" aria-label="Disminuir cantidad" style="width:34px;height:34px;border-radius:6px;border:1px solid #e0e0e0;background:#fff;cursor:pointer;outline:none;box-sizing:border-box;">−</button>
                  <div style="min-width:36px;text-align:center;font-weight:700;">${item.quantity}</div>
                  <button class="qty-increase" data-variant-id="${variantId}" aria-label="Aumentar cantidad" style="width:34px;height:34px;border-radius:6px;border:1px solid #e0e0e0;background:#fff;cursor:pointer;outline:none;box-sizing:border-box;">+</button>
                </div>

                <div style="font-size:12px;color:#666;">
                  <button class="remove-item" data-variant-id="${variantId}" style="background:transparent;border:0;color:#f8f9fa;cursor:pointer;font-weight:600;outline:none;box-sizing:border-box;"><span>Eliminar</span></button>
                </div>
              </div>
            </div>
          </div>
        `;
      });

      const currentCurrency = this.getCurrentCurrency();
      const isShowingCLP = currentCurrency === 'CLP';
      
      // Re-verificar país también aquí en renderFullCart
      const cacheRaw = localStorage.getItem('visitor_country_cache');
      let currentCountry = this.visitorCountry || 'ZZ';
      if (cacheRaw) {
        try {
          const cache = JSON.parse(cacheRaw);
          if (cache.country) currentCountry = cache.country;
        } catch (e) {}
      }
      const isChile = currentCountry === 'CL';
      
      const hasFreeSantiago = isChile && isShowingCLP && cart.total_price >= this.freeShippingSantiago;
      const hasFreeRegiones = isChile && isShowingCLP && cart.total_price >= this.freeShippingRegiones;

      cartHTML += `
        <div style="margin-top:10px;padding:12px;background:#f8f9fa;border-radius:8px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
            <span style="font-size:18px;font-weight:600;"><span>Subtotal:</span></span>
            <span style="font-size:22px;font-weight:700;">${this.formatPriceForConversion(cart.total_price)}</span>
          </div>
          ${isChile && isShowingCLP ? (hasFreeRegiones ? `
            <div style="display:flex;align-items:center;gap:8px;padding:8px 12px;background:linear-gradient(135deg,#F0FFF0 0%, #e6ffe6 100%);border-radius:6px;margin-bottom:8px;">
              <span style="font-size:16px;">🎉</span>
              <span style="font-size:13px;font-weight:600;color:#228B22;"><span>¡Envío GRATIS a todo Chile!</span></span>
            </div>
          ` : hasFreeSantiago ? `
            <div style="display:flex;align-items:center;gap:8px;padding:8px 12px;background:linear-gradient(135deg,#fff5f5 0%, #ffe6e6 100%);border-radius:6px;margin-bottom:8px;">
              <span style="font-size:16px;">🎉</span>
              <span style="font-size:13px;font-weight:600;color:#228B22;"><span>¡Envío GRATIS a Santiago!</span></span>
            </div>
          ` : ``) : ``}
        </div>
      `;
    }

    cartHTML += `</div>`;

    cartHTML += `
      <div id="recommendations-container" style="border-top:2px solid #e5e5e5;padding:20px;">
        <h3 style="margin:0 0 12px;font-size:18px;font-weight:600;color:#1a1a1a;">✨ <span>También te podría gustar</span></h3>
        <div id="recommendations-grid" style="display:grid; gap:12px;"></div>
      </div>
    `;

    fullCartContainer.innerHTML = cartHTML;
  }

  getCustomRecommendations(productTitle) {
    const rules = {
      'plotulopi': ['jazmine', 'einband'],
      'plotu lopi': ['jazmine', 'einband'],
      'plötulopi': ['jazmine', 'einband'],
      'lettlopi': ['jazmine', 'aurora'],
      'léttlopi': ['jazmine', 'aurora'],
      'letlopi': ['jazmine', 'aurora'],
      'Létlopi': ['jazmine', 'aurora'],
      'fjllalopi': ['jazmine', 'aurora'],
      'fjalla lopi': ['jazmine', 'aurora'],
      'fjälla lopi': ['jazmine', 'aurora'],
      'alafosslopi': ['vovo', 'mondim'],
      'álafosslopi': ['vovo', 'mondim'],
      'alafoss lopi': ['vovo', 'mondim'],
      'álafoss lopi': ['vovo', 'mondim'],
      'einband': ['jazmine', 'aurora'],
      'ein band': ['jazmine', 'aurora'],
      'mondim': ['vovo', 'plotulopi'],
      'mon dim': ['vovo', 'plotulopi'],
      'vovo': ['mondim', 'brusca'],
      'vovó': ['mondim', 'brusca'],
      'vo vo': ['mondim', 'brusca'],
      'vó vó': ['mondim', 'brusca'],
      'brusca': ['mondim', 'vovo'],
      'aurora': ['jazmine', 'blancanieves'],
      'patagonia': ['jazmine', 'mondim'],
      'jazmine': ['aurora', 'plotulopi'],
      'jasmine': ['aurora', 'plotulopi'],
      'jazmín': ['aurora', 'plotulopi'],
      'jazmin': ['aurora', 'plotulopi'],
      'blancanieves': ['aurora', 'jazmine'],
      'blanca nieves': ['aurora', 'jazmine'],
      'blancanieve': ['aurora', 'jazmine']
    };

    const normalizedTitle = this.normalizeText(productTitle);
    
    for (const [keyword, recommendations] of Object.entries(rules)) {
      if (normalizedTitle.includes(keyword)) {
        return recommendations;
      }
    }

    return null;
  }

  normalizeText(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  renderRecommendations(recommendations, container) {
    // Refuerzo: obtener la moneda activa antes de renderizar
    const currentCurrency = this.getCurrentCurrency();
    container.innerHTML = recommendations.map((product) => {
      const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
      let price = 0;
      let comparePrice = null;
      if (product.variants && product.variants[0]) {
        price = product.variants[0].price ? product.variants[0].price : 0;
        comparePrice = product.variants[0].compare_at_price ? product.variants[0].compare_at_price : null;
      } else if (product.price) {
        price = product.price ? product.price : 0;
        comparePrice = product.compare_at_price ? product.compare_at_price : null;
      }
      let imageUrl = '';
      if (product.featured_image) {
        imageUrl = product.featured_image;
      } else if (product.image && product.image.src) {
        imageUrl = product.image.src;
      } else if (product.images && product.images.length > 0) {
        imageUrl = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
      }
      const vendor = product.vendor || '';
      const productUrl = product.url || `/products/${product.handle}`;

      return `
        <div class="recommendation-item" style="display:flex; gap:12px; padding:12px; border:1px solid #eaeaea; border-radius:8px; margin-bottom:12px; background:#fff;">
          ${imageUrl ? `
            <div style="flex-shrink:0;">
              <a href="${productUrl}" style="display:block; text-decoration:none;">
                <img src="${imageUrl}" alt="${product.title}" style="width:80px; height:80px; object-fit:cover; border-radius:6px;" onerror="this.style.display='none';">
              </a>
            </div>
          ` : ''}
          <div style="flex:1; min-width:0;">
            <div style="margin-bottom:10px;">
              <div style="min-width:0;">
                ${vendor ? `<p style="font-size:11px; text-transform:uppercase; color:#999; margin:0 0 4px;">${vendor}</p>` : ''}
                <a href="${productUrl}" style="text-decoration:none;">
                  <h4 style="margin:0; font-size:14px; font-weight:600; color:#1a1a1a; line-height:1.2; overflow:hidden; text-overflow:ellipsis; cursor:pointer; transition:color 0.2s;">${product.title}</h4>
                </a>
              </div>
            </div>
            <div style="display:flex; align-items:center; justify-content:flex-end;">
              ${variantId ? `
                <button class="add-recommendation" data-variant-id="${variantId}" style="padding:8px 16px; border-radius:6px; border:0; background:#700e25; color:#fff; cursor:pointer; font-weight:600; font-size:13px; outline:none; box-sizing:border-box;"><span>Agregar</span></button>
              ` : `
                <span style="font-size:11px; color:#999;"><span>No disponible</span></span>
              `}
            </div>
          </div>
        </div>
      `;
    }).join('');
    // ⚠️ IMPORTANTE: Disparar conversión de moneda DESPUÉS de renderizar
    setTimeout(() => this.triggerCurrencyConversion(), 50);
    setTimeout(() => this.triggerCurrencyConversion(), 300);
    setTimeout(() => this.triggerCurrencyConversion(), 600);
    setTimeout(() => this.triggerCurrencyConversion(), 1000);
    // Refuerzo extra: disparar conversión si la moneda cambia
    document.addEventListener('mlveda_currency_changed', () => {
      this.triggerCurrencyConversion();
    });
    document.addEventListener('currency_switcher:currency_changed', () => {
      this.triggerCurrencyConversion();
    });
    }

  async loadRecommendations(cart) {
    const recommendationsGrid = this.notification.querySelector('#recommendations-grid');
    if (!recommendationsGrid) return;

    if (!cart.items.length) {
      recommendationsGrid.innerHTML = '<p style="text-align:center;color:#999;padding:12px;"><span>Agrega productos para obtener recomendaciones</span></p>';
      return;
    }

    try {
      const firstProduct = cart.items[0];
      const productTitle = firstProduct.product_title;

      const keywords = this.getCustomRecommendations(productTitle);

      if (!keywords || keywords.length === 0) {
        const response = await fetch(`/recommendations/products.json?product_id=${firstProduct.product_id}&limit=6`);
        const data = await response.json();
        
        if (!data.products || !data.products.length) {
          recommendationsGrid.innerHTML = '<p style="text-align:center;color:#999;padding:12px;"><span>No hay recomendaciones disponibles</span></p>';
          return;
        }

        const cartProductIds = cart.items.map((i) => i.product_id);
        const recommendations = data.products.filter((p) => !cartProductIds.includes(p.id)).slice(0, 4);
        
        this.renderRecommendations(recommendations, recommendationsGrid);
        
        // 💱 Conversión en cascada después del render
        setTimeout(() => this.triggerCurrencyConversion(), 100);
        setTimeout(() => this.triggerCurrencyConversion(), 400);
        setTimeout(() => this.triggerCurrencyConversion(), 800);
        setTimeout(() => this.triggerCurrencyConversion(), 1200);
        return;
      }

      const productsByKeyword = {};
      
      const response = await fetch(`/products.json?limit=250`);
      const data = await response.json();
      
      if (data.products) {
        keywords.forEach(keyword => {
          const normalizedKeyword = this.normalizeText(keyword);
          
          const filtered = data.products.filter(product => {
            const normalizedTitle = this.normalizeText(product.title);
            return normalizedTitle.includes(normalizedKeyword);
          });
          
          productsByKeyword[keyword] = filtered;
        });
      }

      let finalRecommendations = [];
      
      keywords.forEach(keyword => {
        const productsForKeyword = productsByKeyword[keyword] || [];
        const productsToAdd = productsForKeyword.slice(0, 2);
        finalRecommendations = finalRecommendations.concat(productsToAdd);
      });

      const uniqueProducts = [];
      const seenIds = new Set();
      
      finalRecommendations.forEach(product => {
        if (!seenIds.has(product.id)) {
          seenIds.add(product.id);
          uniqueProducts.push(product);
        }
      });

      if (!uniqueProducts.length) {
        recommendationsGrid.innerHTML = '<p style="text-align:center;color:#999;padding:12px;"><span>No se encontraron productos relacionados</span></p>';
        return;
      }

      const cartProductIds = cart.items.map((i) => i.product_id);
      const recommendations = uniqueProducts.filter((p) => !cartProductIds.includes(p.id));

      if (!recommendations.length) {
        recommendationsGrid.innerHTML = '<p style="text-align:center;color:#999;padding:12px;"><span>Todos los productos recomendados ya están en tu carrito</span></p>';
        return;
      }

      this.renderRecommendations(recommendations, recommendationsGrid);
      
      // 💱 Conversión múltiple en cascada para máxima compatibilidad
      setTimeout(() => this.triggerCurrencyConversion(), 100);
      setTimeout(() => this.triggerCurrencyConversion(), 400);
      setTimeout(() => this.triggerCurrencyConversion(), 800);
      setTimeout(() => this.triggerCurrencyConversion(), 1200);

    } catch (error) {
      console.error('❌ Error cargando recomendaciones:', error);
      recommendationsGrid.innerHTML = '<p style="text-align:center;color:#999;padding:12px;"><span>Error al cargar recomendaciones</span></p>';
    }
  }

  async handleInternalClick(e) {
    let target = e.target;
    
    // Si el clic fue en un span dentro del botón, busca el botón padre
    if (target.tagName === 'SPAN') {
      target = target.closest('button');
    }
    
    if (!target) return;

    if (target.matches('.qty-increase')) {
      const variantId = target.getAttribute('data-variant-id');
      await this.changeItemQuantityByVariant(variantId, 1);
      return;
    }
    if (target.matches('.qty-decrease')) {
      const variantId = target.getAttribute('data-variant-id');
      await this.changeItemQuantityByVariant(variantId, -1);
      return;
    }
    if (target.matches('.remove-item')) {
      const variantId = target.getAttribute('data-variant-id');
      await this.setItemQuantityToZero(variantId);
      return;
    }
    if (target.matches('.add-recommendation')) {
      const variantId = target.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('No variant id disponible para agregar');
        return;
      }
      await this.addVariantToCart(variantId, 1);
      return;
    }
  }

  async changeItemQuantityByVariant(variantId, delta) {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const item = cart.items.find((i) => String(i.variant_id) === String(variantId));
      if (!item) {
        console.warn('Item no encontrado en carrito para variant:', variantId);
        return;
      }

      const newQty = Math.max(item.quantity + delta, 0);
      await this.updateCartByVariant(variantId, newQty);
    } catch (err) {
      console.error('❌ Error cambiando cantidad:', err);
    }
  }

  async setItemQuantityToZero(variantId) {
    await this.updateCartByVariant(variantId, 0);
  }

  async updateCartByVariant(variantId, quantity) {
    try {
      const payload = new URLSearchParams();
      payload.append('id', variantId);
      payload.append('quantity', String(quantity));

      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: payload.toString()
      });

      if (!res.ok) {
        const text = await res.text();
        console.error('❌ Error en /cart/change.js', res.status, text);
        return;
      }

      await this.loadFullCart();
      console.log('✅ Cantidad actualizada (variant:', variantId, '->', quantity, ')');
    } catch (err) {
      console.error('❌ Error actualizando carrito:', err);
    }
  }

  async addVariantToCart(variantId, quantity = 1) {
    try {
      const payload = { id: variantId, quantity: quantity };
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const text = await res.text();
        console.error('❌ Error en /cart/add.js', res.status, text);
        return;
      }

      const added = await res.json();
      console.log('➕ Producto agregado:', added);

      await this.loadFullCart();
      await this.updateCartIcon();

      this.flashMessage('<span>Producto agregado al carrito</span>');
    } catch (err) {
      console.error('❌ Error agregando al carrito:', err);
    }
  }

  flashMessage(text) {
    const id = 'cart-flash-message';
    let el = this.notification.querySelector(`#${id}`);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.style.cssText = 'position:fixed; top:16px; right:16px; z-index:10010; background:#111; color:#fff; padding:10px 14px; border-radius:8px; box-shadow:0 6px 18px rgba(0,0,0,0.2); font-weight:600;';
      this.notification.appendChild(el);
    }
    // Si el texto contiene HTML (con span), usar innerHTML; si no, usar textContent
    if (text.includes('<')) {
      el.innerHTML = text;
    } else {
      el.textContent = text;
    }
    el.style.opacity = '1';
    setTimeout(() => {
      if (el) el.style.opacity = '0';
    }, 1700);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (el) {
        el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

console.log('🎯 SLIDE CART MEJORADO - VERSIÓN FINAL ✅');
console.log('✅ Conversión de moneda mejorada con múltiples métodos');
console.log('✅ Precios de recomendaciones ahora usan formatPriceForConversion()');
console.log('✅ Conversión en cascada con delays incrementales');